function mountGoogleAFSAds() {
  const placementIds = Object.keys(this.adPlacements);
  const { pubId, styleId, abTestGChannel } = this.adContext;

  if (!placementIds || !pubId || !styleId) {
    throw new Error('Missing placementIds, pubId, and/or styleId');
  }

  const { q, rch, crch } = this.pageParams;
  const afsQuery = q || this.doc.title;

  const adsenseScript = this.doc.createElement('script');
  adsenseScript.src = 'https://www.google.com/adsense/search/ads.js';
  adsenseScript.async = 'async';
  this.doc.head.appendChild(adsenseScript);

  const csaScript = this.doc.createElement('script');
  csaScript.setAttribute('type', 'text/javascript');
  csaScript.innerHTML = `(function(g,o){g[o]=g[o]||function(){(g[o]['q']=g[o]['q']||[]).push(
    arguments)},g[o]['t']=1*new Date})(window,'_googCsa');`;

  this.doc.head.appendChild(csaScript);

  const afsPageOptions = {
    pubId,
    styleId,
    query: afsQuery,
    channel: this.appendABTestChannel(crch || rch, abTestGChannel),
    linkTarget: '_blank',
  };

  this.firePageViewPixel();
  const conversionUrls = this.getAfsConversionPixelUrls();
  const hasClkUrl = this.constructor.containsArchieClickUrl(conversionUrls);
  if (hasClkUrl) {
    this.enqueuePollingfn(this.watchForCsaCookie);
  }

  let adBlocks = '';
  placementIds.forEach((id, idx) => {
    adBlocks += `const adBlock${idx + 1} = {
                    container: '${id}',
                    width: 700,
                    ${conversionUrls ? `clicktrackUrl: ${JSON.stringify(conversionUrls)},` : ''}
                    adLoadedCallback: function (containerId, adsLoaded) {
                      const afsLogger = window.amgAds.afs.adPlacements.${id}.logger;
                      afsLogger.debug('AFS adsLoaded', adsLoaded);
                      const parentCallback = window.amgAds.adsLoadedCallback || function() {};
                      if (adsLoaded) {
                        // google's products don't know about each other
                        // and they will create iframes for different prodcts with the same ids
                        // this is a workaround to prevent this clobering from taking place
                        const selector = '#' + containerId + ' > iframe';
                        const iframes = document.querySelectorAll(selector);
                        const ro = new ResizeObserver(function (entries, observer) {
                          entries.forEach(function(entry){
                            if (entry.target.clientHeight > 1) {
                              afsLogger.debug('Renaming: ', containerId + ' > ' + entry.target.id);
                              entry.target.id += 'rendered'
                              // unmount observer
                            };
                          });
                        });
                        Array.prototype.forEach.call(iframes, function (iframe) {
                          ro.observe(iframe);
                        });
                        parentCallback(null, containerId);
                      } else {
                        parentCallback(new Error('Ad not loaded.'), containerId);
                      }
                    }
                  };

                  adBlocks.push(adBlock${idx + 1});
                  `;
  });

  const afsScript = document.createElement('script');
  afsScript.setAttribute('type', 'text/javascript');
  afsScript.innerHTML = `
    const googeAfsPageOption = ${JSON.stringify(afsPageOptions)};
    const adBlocks = [];

    ${adBlocks}

    _googCsa('ads', googeAfsPageOption, adBlocks);
    `;

  this.doc.body.appendChild(afsScript);
  this.logger.debug('Mounting Google AFS to dom nodes', this.dataset.dabuPlacementId);
}

async function getGoogleAFSParams() {
  const { o, gStyleId, maxSKSResults } = this.pageParams;
  const { gStyleId: dataGStyleId } = this.dataset;

  if (!o) {
    throw new Error('Missing ocode');
  }

  const dabuUrl = new URL(`${this.dabuUrl}/api/v2/ta/google`);
  dabuUrl.searchParams.set('o', o);
  dabuUrl.searchParams.set('sessionId', this.pvId);
  if (maxSKSResults) {
    dabuUrl.searchParams.set('maxSKSResults', maxSKSResults);
  }
  try {
    // there should only be one item in this array
    const dabuRes = await this.callDabu(dabuUrl.toString());
    const { pubId, styleId, googleChannel } = dabuRes;
    this.logger.debug('AFS Getting pubId and styleId by ocode', pubId, styleId);

    const finalStyleId = gStyleId || dataGStyleId || styleId;
    this.adContext.adType = 'afs';
    this.adContext.pubId = pubId;
    this.adContext.styleId = finalStyleId;
    this.adContext.abTestGChannel = googleChannel;
    this.mountGoogleAFSAds();
  } catch (err) {
    this.logger.error('Error making dabu call or mounting Google AFS ads.', err);
  }
}

export { getGoogleAFSParams, mountGoogleAFSAds };
